// extracted by mini-css-extract-plugin
export var divider = "_os-0";
export var systemMessage = "_os-1";
export var systemMessageWrapper = "_os-2";